var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import messages from '../emailMessages';
import AutoComplete from '../../input/select/AutoComplete';
import { getUserClassName } from '../../input/UserSearch';
var EmployeeEmailRecipients = function (_a) {
    var values = _a.values, type = _a.type, options = _a.options, onRemove = _a.onRemove, onChange = _a.onChange, showRemoveButton = _a.showRemoveButton, intl = _a.intl;
    if (!values)
        return null;
    return (_jsx(_Fragment, { children: values.map(function (x, index) {
            var key = "".concat(type, "-").concat(index);
            return (_jsxs("div", __assign({ className: "row margin10B" }, { children: [_jsx("div", __assign({ className: "col-md-11" }, { children: _jsx(AutoComplete, { value: x, items: options, onChange: function (val) { var _a; return onChange(type, index, (_a = val === null || val === void 0 ? void 0 : val.value) !== null && _a !== void 0 ? _a : ''); }, name: key, mode: "edit", placeholder: intl.formatMessage(messages.SelectEmailAddress), itemClassNameFunc: getUserClassName }, key) })), _jsx("div", __assign({ className: "col-md-1", style: {
                            paddingLeft: '0px',
                            marginTop: '5px',
                        } }, { children: showRemoveButton && (_jsx("a", __assign({ onClick: function () { return onRemove(type, index); }, title: intl.formatMessage(messages.RemoveEmailAddress), className: "clickable" }, { children: _jsx("i", { className: "fa fa-remove" }) }))) }))] }), key));
        }) }));
};
export default EmployeeEmailRecipients;
